import { Parameter } from "domain/entities/parameter";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";

const StatusInvoiceDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {
  const [InvoiceStatusOptions, setInvoiceStatusOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const { invoiceStatus, setInvoiceStatus } = useParameterStore();

  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    sortBy: "value",
  } as BaseInputFilter);

  useEffect(() => {
    setInvoiceStatus(
      parameters?.data?.filter((item) => item.type === "invoiceStatus")
    );
  }, [parameters]);

  useEffect(() => {
    setInvoiceStatusOptions(
      invoiceStatus.map((item: Parameter) => ({
        label: item.value,
        value: item.value,
      }))
    );
  }, [invoiceStatus]);

  return (
    <Dropdown
      value={options.value}
      options={InvoiceStatusOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o status"
      showClear
    />
  );
};
export default StatusInvoiceDropdown;
